import { render } from "./NomineePanel.vue?vue&type=template&id=1c192fbc"
import script from "./NomineePanel.vue?vue&type=script&lang=js"
export * from "./NomineePanel.vue?vue&type=script&lang=js"

import "./NomineePanel.vue?vue&type=style&index=0&id=1c192fbc&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__